export default () => ({
  type: "DRAGGING/END"
});
